export default [
    {
        path: '/',
        redirect: 'checkLogin'
    },
    {
        path: '/home',
        name: 'home',
        meta: {
            title: SFERE_config.nav_title ? SFERE_config.nav_title : '我的云憬' //动态显示名称
        },
        component: () => import("@/modules/home/components/Home.vue")
    },
    {
        path: '/error_404',
        name: 'error_404',
        meta: {
            title: '404'
        },
        component: () =>
            import('@/modules/404.vue')
    },
    {
        path: '/depositRecords',
        name: 'depositRecords',
        meta: {
            title: '充值记录'
        },
        component: () => import('@/modules/deposit-records/components/deposit-records.vue')
    },
    {
        path: '/recordDetail',
        name: 'recordDetail',
        meta: {
            title: '充值记录详情'
        },
        component: () => import('@/modules/deposit-records/components/record-detail.vue')
    },
    {
        path: '/bill',
        name: 'bill',
        meta: {
            title: '账单'
        },
        component: () => import('@/modules/bill/components/bill.vue')
    },
    {
        path: '/dosage',
        name: 'dosage',
        meta: {
            title: '用量查询'
        },
        component: () => import('@/modules/dosage/components/dosage.vue')
    },
    {
        path: '/myRooms',
        name: 'myRooms',
        meta: {
            title: '我的房间'
        },
        component: () => import('@/modules/my-rooms/components/my-rooms.vue')
    },
    {
        path: '/userBind',
        name: 'userBind',
        meta: {
            title: '登录'
        },
        component: () => import('@/modules/user-bind/components/user-bind.vue')
    },
    {
        path: '/checkLogin',
        name: 'checkLogin',
        meta: {
            title: '请稍等...'
        },
        component: () => import('@/modules/user-bind/components/check-login.vue')
    },
    {
        path: '/changePhoneNumber',
        name: 'changePhoneNumber',
        meta: {
            title: '更改手机号'
        },
        component: () => import('@/modules/change-phone-number/components/change-phone-number.vue')
    },
    {
        path: '/customerService',
        name: 'customerService',
        meta: {
            title: '联系客服'
        },
        component: () => import('@/modules/customer-service/components/customer-service.vue')
    },
    // 充值跳转判断
    {
        path: '/fundRedirect',
        name: 'fundRedirect',
        meta: {
            title: '请稍等...'
        },
        component: () => import('@/modules/fund/components/fund-redirect.vue')
    },
    //选择项目
    {
        path: '/fundProject',
        name: 'fundProject',
        meta: {
            title: '选择项目'
        },
        component: () => import("@/modules/fund/components/fund-project.vue")
    },
    //选择充值类型（整体，单房间）
    {
        path: '/fundType',
        name: 'fundType',
        meta: {
            title: '充值'
        },
        component: () => import("@/modules/fund/components/fund-type.vue")
    },
    //整体充值
    {
        path: '/fundWhole',
        name: 'fundWhole',
        meta: {
            title: '充值'
        },
        component: () => import("@/modules/fund/components/fund-whole.vue")
    },
    //多房间-充值
    {
        path: '/fundWrite',
        name: 'fundWrite',
        meta: {
            title: '充值'
        },
        component: () => import("@/modules/fund/components/fund-write.vue")
    },
    //单个房间-充值
    {
        path: '/fundSingle',
        name: 'fundSingle',
        meta: {
            title: '充值'
        },
        component: () => import("@/modules/fund/components/fund-single.vue")
    },
    //充值结果反馈
    {
        path: '/fundFeedback',
        name: 'fundFeedback',
        meta: {
            title: '充值'
        },
        component: () => import("@/modules/fund/components/fund-feedback.vue")
    },
];
